import { FeatureAccessSettingsClients } from '@ms/yammer-graphql';

import { NormalizedFeatureAccessSettings } from './types';

type FeatureAccessSettingsNormalizer = (response: {
  readonly data: FeatureAccessSettingsClients;
}) => NormalizedFeatureAccessSettings;

export const normalizeFeatureAccessSettings: FeatureAccessSettingsNormalizer = (response) => ({
  isPremiumStorylinePreviewEnabled: response.data.settings.storyline.isPremiumStorylinePreviewEnabled,
  canUseDelegateTeamsOnStoryline: response.data.settings.storyline.canUseDelegateTeamsOnStoryline,
  viewerCanAccessStories: response.data.settings.stories.viewerCanAccessStories,
  viewerCanAccessStoryline: response.data.settings.storyline.viewerCanAccessStoryline,
  viewerCanPostStorylineAnnouncement: response.data.settings.storyline.viewerCanPostStorylineAnnouncement,
  viewerCanAccessLeadershipCorner: response.data.settings.leader.viewerCanAccessLeadershipCorner,
  viewerCanAccessLeadershipActivity: response.data.viewer.canViewLeadershipActivity,
  viewerCanDesignateLeaders: response.data.viewer.canDesignateLeaders,
});
